var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42259 0.244078C6.09715 -0.0813592 5.56952 -0.0813592 5.24408 0.244078L0.244079 5.24408C-0.0813589 5.56951 -0.0813589 6.09715 0.244079 6.42259L5.24408 11.4226C5.56952 11.748 6.09715 11.748 6.42259 11.4226C6.74803 11.0972 6.74803 10.5695 6.42259 10.2441L2.84518 6.66667H14.1667C14.6269 6.66667 15 6.29357 15 5.83333C15 5.3731 14.6269 5 14.1667 5H2.84518L6.42259 1.42259C6.74803 1.09715 6.74803 0.569515 6.42259 0.244078Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnArrowLeft);
export default __webpack_public_path__ + "static/media/icn-arrow-left.2789331507363213219e193fc12f31ab.svg";
export { ForwardRef as ReactComponent };